import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { Queue } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/Queue" component={Queue} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Queue/routes.js